<template>
  <a-card>
    <a-tabs defaultActiveKey="1" >
      <!-- 排课结果查询 -->
      <a-tab-pane key="1" tab="排课结果查询">
        <ScheduleQuery />
      </a-tab-pane>
      
      <!-- 跨校区检测 -->
      <a-tab-pane key="2" tab="跨校区检测">
        <cross-campus-check />
      </a-tab-pane>
      
      <!-- 学时统计 -->
      <a-tab-pane key="3" tab="学时统计">
        <hour-statistics />
      </a-tab-pane>
      
      <!-- 班级课表分析 -->
      <a-tab-pane key="4" tab="班级课表分析">
        <class-analysis />
      </a-tab-pane>
      
      <!-- 不合理排课检测 -->
      <a-tab-pane key="5" tab="不合理排课检测">
        <irregular-schedule />
      </a-tab-pane>
      
      <!-- 教室使用率 -->
      <a-tab-pane key="6" tab="教室使用率">
        <classroom-utilization />
      </a-tab-pane>
      
      <!-- 时间段查询 -->
      <a-tab-pane key="7" tab="时间段查询">
        <time-range-query />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import ScheduleQuery from './modules/ScheduleQuery'
import CrossCampusCheck from './modules/CrossCampusCheck'
import HourStatistics from './modules/HourStatistics'
import ClassAnalysis from './modules/ClassAnalysis'
import IrregularSchedule from './modules/IrregularSchedule'
import ClassroomUtilization from './modules/ClassroomUtilization'
import TimeRangeQuery from './modules/TimeRangeQuery'

export default {
  components: {
    ScheduleQuery,
    CrossCampusCheck,
    HourStatistics,
    ClassAnalysis,
    IrregularSchedule,
    ClassroomUtilization,
    TimeRangeQuery
  }
}
</script>